import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { useParams, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import ApiClient from "../BaseUrl/ApiClient";
import "react-toastify/dist/ReactToastify.css";

function ResturantDetail() {
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { id } = useParams();
  const history = useHistory();

  const getBusinessDetails = async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      const res = await ApiClient().get(`/business/admin/${id}`);
      const businessData = res?.data?.responseData?.business;

      if (!businessData) {
        throw new Error("No business data");
      }

      setBusiness(businessData);
    } catch (err) {
      console.error(err);
      setError("Failed to load business details");
      toast.error("Failed to load business details");

      if (err?.response?.status === 401) {
        localStorage.clear();
        history.push("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBusinessDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="business-loader d-flex flex-column justify-content-center align-items-center">
        <div className="spinner-border text-primary" />
        <p className="mt-3">Loading business details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5">
        <p className="text-danger">{error}</p>
        <Button color="primary" onClick={getBusinessDetails}>
          Retry
        </Button>
      </div>
    );
  }

  const renderLink = (url) =>
    url ? (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    ) : (
      "-"
    );

  const to12HourFormat = (time24) => {
    if (!time24) return "-";

    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return `${hour.toString().padStart(2, "0")}:${minute} ${ampm}`;
  };

  const renderTimeRange = (startTime, endTime) => {
    if (!startTime && !endTime) return "-";
    if (!startTime) return to12HourFormat(endTime);
    if (!endTime) return to12HourFormat(startTime);
    return `${to12HourFormat(startTime)} - ${to12HourFormat(endTime)}`;
  };

  return (
    <>
      <ToastContainer />
      <div className="page-content business-detail-page">
        <MetaTags>
          <title>Business Detail</title>
        </MetaTags>

        <Container>
          <Row>
            <Col md={12}>
              <Card className="business-detail-card">
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h4>Business Details</h4>
                  <Button
                    color="primary"
                    className="back-btn"
                    onClick={() => history.push("/business-list")}
                  >
                    Back to List
                  </Button>
                </CardHeader>

                <CardBody>
                  {business && (
                    <Row>
                      {/* LOGO */}
                      <Col md={2} className="business-logo-wrapper mb-4">
                        {business.logoImage?.url ? (
                          <img
                            src={business.logoImage.url}
                            alt={business.businessName}
                            className="business-logo"
                          />
                        ) : (
                          <div className="text-muted">No logo</div>
                        )}
                      </Col>

                      {/* DETAILS */}
                      <Col md={10}>
                        <h3 className="business-name">
                          {business.businessName}
                        </h3>

                        <div className="business-info mb-3">
                          <p>
                            <strong>Location:</strong>{" "}
                            {business.businessLocation?.streetAddress || "-"},{" "}
                            {business.businessLocation?.city || "-"},{" "}
                            {business.businessLocation?.state || "-"},{" "}
                            {business.businessLocation?.postalCode || "-"}
                          </p>
                        </div>

                     

                          <p>
                            <strong>Google Link:</strong>{" "}
                            {renderLink(business.googleBusinessLink)}
                          </p>

                          <p>
                            <strong>Lunch Special:</strong>{" "}
                            {renderTimeRange(
                              business.lunchSpecialStartTime,
                              business.lunchSpecialEndTime
                            )}
                          </p>

                        
                        
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ResturantDetail;
